<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.upload_file.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>
        <form>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-file-input
                v-model="file"
                accept=".csv"
                show-size
                :label="$t('lang.admin.upload_file.select_file')"
                outlined
                truncate-length="50"
                prepend-icon="mdi-file"
                color="#9ac31c"
              ></v-file-input>
            </div>
          </div>

          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn type="reset" @click="$router.back()" text rounded>{{
                $t("lang.admin.add_user.btn_cancel")
              }}</v-btn>
              <bx-btn type="submit" color="primary" @click="uploadfile">{{
                $t("lang.admin.upload_file.submit")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadPrinterFile",
  props: ["id"],
  data() {
    return {
      file: null,
      errors: [],
      success: {
        show: false,
        message: this.$t("lang.admin.upload_file.success_upload")
      },
      errorLabels: {
        failed: this.$t("lang.messages.label_something_went_wrong"),
        selectFile: this.$t("lang.admin.upload_file.error_select_file")
      }
    };
  },
  methods: {
    async uploadfile() {
      if (this.validate()) {
        try {
          var fileCode = await this.$api.printer.fileUpload(this.file);
          var printResponse = await this.$api.printer.printUploadedFile(
            fileCode,
            this.id
          );
          if (printResponse) {
            this.file = null;
            this.success.show = true;
            this.routePage();
          }
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.file) {
        error = true;
        this.errors.push(this.errorLabels.selectFile);
      }

      if (error) {
        return false;
      }

      return true;
    },
    routePage() {
      setTimeout(() => {
        this.$router.push({ name: "PrintersList" });
      }, 8000);
    }
  }
};
</script>
